import { render, staticRenderFns } from "./Paymentypes.vue?vue&type=template&id=484fd2be&scoped=true"
import script from "./Paymentypes.vue?vue&type=script&lang=js"
export * from "./Paymentypes.vue?vue&type=script&lang=js"
import style0 from "./Paymentypes.vue?vue&type=style&index=0&id=484fd2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fd2be",
  null
  
)

export default component.exports